export const AUTH_COOKIE_NAME = 'Authorization';
